const e = {
  aquamarine50: "#DCF2EB",
  aquamarine100: "#A9DFCC",
  aquamarine200: "#6ECAAB",
  aquamarine300: "#30B38B",
  aquamarine400: "#00A276",
  aquamarine500: "#009163",
  aquamarine600: "#008458",
  aquamarine700: "#00744A",
  aquamarine800: "#00643D",
  aquamarine900: "#004824",
  electricBlue0: "#FFFFFF",
  electricBlue25: "#F7F8FA",
  electricBlue50: "#EBEEF2",
  electricBlue100: "#CDD4DC",
  electricBlue200: "#AEB8C3",
  electricBlue300: "#8E9CAB",
  electricBlue400: "#768698",
  electricBlue500: "#5F7287",
  electricBlue600: "#526476",
  electricBlue600A80: "rgba(82, 100, 118, 0.8)",
  electricBlue700: "#425160",
  electricBlue800: "#333E4A",
  electricBlue900: "#222A33",
  electricBlue900A80: "rgba(34, 42, 51, 0.8)",
  paleCerulean50: "#E4F2F6",
  paleCerulean100: "#BBDEE9",
  paleCerulean200: "#95C8DA",
  paleCerulean300: "#71B4CE",
  paleCerulean400: "#54A6CA",
  paleCerulean500: "#3C99C6",
  paleCerulean600: "#368CB8",
  paleCerulean700: "#2D7AA6",
  paleCerulean800: "#266993",
  paleCerulean900: "#124B75",
  peach50: "#FCF5F2",
  peach100: "#FFE5D8",
  peach200: "#FDBD9A",
  peach300: "#FF8E7A",
  peach400: "#FF755E",
  peach500: "#FF5A44",
  peach600: "#F8543F",
  peach700: "#EA4E3A",
  peach800: "#DB4735",
  peach900: "#C23B2C",
  pomegranate50: "#FFEDF1",
  pomegranate100: "#FFD2D9",
  pomegranate200: "#F2A2A7",
  pomegranate300: "#EA7F85",
  pomegranate400: "#F76267",
  pomegranate500: "#FE514F",
  pomegranate600: "#F04A4E",
  pomegranate700: "#DE4047",
  pomegranate800: "#D13A3F",
  pomegranate900: "#C22F33",
  tangelo50: "#FFF3EC",
  tangelo100: "#FFE7D7",
  tangelo200: "#FFCEB0",
  tangelo300: "#FFB689",
  tangelo400: "#FFAA6C",
  tangelo500: "#FF914F",
  tangelo600: "#FF782D",
  tangelo700: "#FA6118",
  tangelo800: "#D05112",
  tangelo900: "#A6410C",
  teal50: "#E0F2F1",
  teal100: "#C4E8E4",
  teal200: "#A6DDD6",
  teal300: "#7CCCC5",
  teal400: "#4AB9AF",
  teal500: "#3AA097",
  teal600: "#357E78",
  teal700: "#2C5F5A",
  teal800: "#253F3C",
  teal900: "#162524"
}, c = {
  border: {
    accentPrimary10: e.teal300,
    neutral10: e.electricBlue25,
    neutral20: e.electricBlue100,
    neutral30: e.electricBlue300,
    systemError: e.pomegranate300,
    systemInfo: e.paleCerulean200,
    systemSuccess: e.aquamarine200,
    systemWarning: e.tangelo400
  },
  surface: {
    accentPrimary10: e.teal50,
    accentPrimary20: e.teal100,
    accentPrimary30: e.teal200,
    accentPrimary40: e.teal300,
    accentPrimary50: e.teal400,
    accentSecondary10: e.peach50,
    accentSecondary20: e.peach100,
    accentSecondary30: e.peach200,
    accentSecondary40: e.peach300,
    neutral10: e.electricBlue0,
    neutral20: e.electricBlue25,
    neutral30: e.electricBlue50,
    neutral40: e.electricBlue300,
    neutral50: e.electricBlue600,
    systemDisabled10: e.electricBlue50,
    systemDisabled20: e.electricBlue300,
    systemError10: e.pomegranate50,
    systemError20: e.pomegranate300,
    systemInfo10: e.paleCerulean50,
    systemInfo20: e.paleCerulean200,
    systemSuccess10: e.aquamarine50,
    systemSuccess20: e.aquamarine200,
    systemWarning10: e.tangelo100,
    systemWarning20: e.tangelo400,
    overlay: e.electricBlue600A80
  },
  text: {
    accentPrimary10: e.teal500,
    accentPrimary20: e.teal600,
    accentSecondary10: e.peach300,
    neutral10: e.electricBlue0,
    neutral20: e.electricBlue500,
    neutral30: e.electricBlue800,
    systemError: e.pomegranate400,
    systemSuccess: e.aquamarine400,
    systemInfo: e.paleCerulean600,
    systemWarning: e.tangelo600
  }
}, o = {
  border: {
    accentPrimary10: e.teal200,
    neutral10: e.electricBlue800,
    neutral30: e.electricBlue300,
    neutral20: e.electricBlue700,
    systemError: e.pomegranate300,
    systemInfo: e.paleCerulean200,
    systemSuccess: e.aquamarine200,
    systemWarning: e.tangelo400
  },
  surface: {
    accentPrimary10: e.teal900,
    accentPrimary20: e.teal800,
    accentPrimary30: e.teal700,
    accentPrimary40: e.teal600,
    accentPrimary50: e.teal500,
    accentSecondary10: e.electricBlue0,
    accentSecondary20: e.electricBlue0,
    accentSecondary30: e.electricBlue0,
    accentSecondary40: e.peach300,
    neutral10: e.electricBlue600,
    neutral20: e.electricBlue300,
    neutral30: e.electricBlue100,
    neutral40: e.electricBlue50,
    neutral50: e.electricBlue25,
    systemDisabled10: e.electricBlue300,
    systemDisabled20: e.electricBlue50,
    systemError10: e.pomegranate50,
    systemError20: e.pomegranate300,
    systemInfo10: e.paleCerulean700,
    systemInfo20: e.paleCerulean200,
    systemSuccess10: e.aquamarine200,
    systemSuccess20: e.aquamarine50,
    systemWarning10: e.tangelo100,
    systemWarning20: e.tangelo400,
    overlay: e.electricBlue900A80
  },
  text: {
    accentPrimary10: e.teal500,
    accentPrimary20: e.teal600,
    accentSecondary10: e.peach400,
    neutral10: e.electricBlue50,
    neutral20: e.electricBlue300,
    neutral30: e.electricBlue800,
    systemError: e.pomegranate200,
    systemSuccess: e.aquamarine400,
    systemInfo: e.paleCerulean600,
    systemWarning: e.tangelo600
  }
}, d = {
  light: {
    semantic: c
  },
  dark: {
    semantic: o
  }
}, t = {
  radius05: 4,
  radius10: 8,
  radius15: 12,
  radius20: 16,
  radius30: 24,
  radius100: 1024
}, p = {
  xs: t.radius05,
  sm: t.radius10,
  md: t.radius15,
  lg: t.radius20,
  xl: t.radius30,
  full: t.radius100
}, g = {
  xs: t.radius05,
  sm: t.radius10,
  md: t.radius15,
  lg: t.radius20,
  xl: t.radius30,
  full: t.radius100
}, f = {
  desktop: p,
  mobile: g
}, r = {
  spacing00: 2,
  spacing05: 4,
  spacing10: 8,
  spacing20: 16,
  spacing30: 24,
  spacing40: 32,
  spacing50: 40,
  spacing60: 48,
  spacing70: 56,
  spacing80: 64
}, y = {
  "2xs": r.spacing00,
  xs: r.spacing05,
  sm: r.spacing10,
  md: r.spacing20,
  lg: r.spacing30,
  xl: r.spacing40,
  "2xl": r.spacing60
}, F = {
  "2xs": r.spacing00,
  xs: r.spacing05,
  sm: r.spacing10,
  md: r.spacing20,
  lg: r.spacing30,
  xl: r.spacing40,
  "2xl": r.spacing60
}, A = {
  desktop: y,
  mobile: F
}, a = {
  font12: 12,
  font14: 14,
  font16: 16,
  font18: 18,
  font20: 20,
  font24: 24,
  font28: 28,
  font32: 32,
  font40: 40,
  font48: 48
}, B = {
  xs: a.font12,
  sm: a.font14,
  md: a.font16,
  lg: a.font20,
  xl: a.font24,
  "2xl": a.font32,
  "3xl": a.font40,
  "4xl": a.font48
}, C = {
  xs: a.font12,
  sm: a.font14,
  md: a.font16,
  lg: a.font16,
  xl: a.font18,
  "2xl": a.font20,
  "3xl": a.font24,
  "4xl": a.font28
}, E = {
  desktop: B,
  mobile: C
};
function n(l, s = 1) {
  const i = parseInt(l.slice(1, 3), 16), m = parseInt(l.slice(3, 5), 16), u = parseInt(l.slice(5, 7), 16);
  return `rgba(${i}, ${m}, ${u}, ${s})`;
}
const D = {
  resting: {
    neutral10: "0 0.4rem 0.8rem -0.2rem rgba(0,0,0,0.06), 0 0.2rem 0.4rem -0.2rem rgba(0,0,0,0.04)",
    accentPrimary20: `0 0.2rem 0.4rem -0.2rem rgba(0, 0, 0, 0.30), 0 0.4rem 0.8rem -0.1rem ${n(
      c.surface.accentPrimary20
    )}`,
    accentPrimary40: `0 0.2rem 0.4rem -0.2rem rgba(0, 0, 0, 0.50), 0 0.4rem 0.8rem -0.2rem ${n(
      c.surface.accentPrimary40
    )}`
  },
  hovering: {
    neutral10: "0 0.4rem 0.6rem -0.2rem rgba(0,0,0,0.03), 0 1.2rem 1.6rem -0.4rem rgba(0,0,0,0.08)",
    accentPrimary20: `0 0.4rem 0.6rem -0.2rem rgba(0, 0, 0, 0.25), 0 1.2rem 1.6rem -0.6rem ${n(
      c.surface.accentPrimary20,
      0.8
    )}`,
    accentPrimary40: `0 0.4rem 1rem -0.2rem rgba(0, 0, 0, 0.50), 0 1.2rem 1.6rem -0.6rem ${n(
      c.surface.accentPrimary40,
      0.5
    )}`
  }
};
export {
  d as colors,
  E as font,
  e as primitiveColors,
  f as radius,
  D as shadow,
  A as spacing
};
